import './App.css';
import { Mainlayout } from './layouts/Mainlayout';

function App() {
  return (
    <div className='App bg-lightGreen'>
      <Mainlayout />
    </div>
  );
}

export default App;
